import { useEffect } from 'react'
import { useSelector } from '../../../store'
import { selectAuthSource } from '../authorization'
import type { AuthorizationSource } from '../../modules/authorization/reducer'
import { LabraAuthProvider } from './Tracker'
import { useTracker } from './hook'

const labraAuthProviderMap: Record<AuthorizationSource, LabraAuthProvider> = {
  auth0: LabraAuthProvider.Labra,
  'url-jwt': LabraAuthProvider.Hubspot,
  canvas: LabraAuthProvider.Salesforce,
}

export const TrackerLabraAuthProviderBinding = () => {
  const tracker = useTracker()
  const authSource = useSelector(selectAuthSource)

  useEffect(() => {
    if (!tracker) {
      return
    }

    const mappedLabraAuthProvider = authSource
      ? labraAuthProviderMap[authSource]
      : undefined

    tracker.setLabraAuthProvider(mappedLabraAuthProvider)

    if (mappedLabraAuthProvider) {
      tracker.page()
    }
  }, [tracker, authSource])

  return null
}
